export const submitFormat = (data: any) => {
  const selected: any = {
    screening: [],
    visits: [],
    repeating_data: [],
    surveys: [],
    visitsPhaseIds: [],
    screeningPhaseIds: [],
    repeatingDataPhaseIds: [],
    surveysPhaseIds: [],
  };
  data.data.forEach((item: any) => {
    item.formattedData.forEach((phase: any) => {
      const formIds: any[] = [];
      phase.forms.forEach((form: any) => {
        if (form.selected) {
          formIds.push(form.id);
        }
      });
      if (phase.category === "visit") {
        if (formIds.length > 0) {
          selected.visitsPhaseIds.push(phase.id);
          selected.visits.push(...formIds);
        }
      } else if (phase.category === "survey") {
        if (formIds.length > 0) {
          selected.surveysPhaseIds.push(phase.id);
          selected.surveys.push(...formIds);
        }
      } else if (phase.category === "repeated_data") {
        if (formIds.length > 0) {
          selected.repeatingDataPhaseIds.push(phase.id);
          selected.repeating_data.push(...formIds);
        }
      } else if (phase.category === "screening") {
        if (formIds.length > 0) {
          selected.screeningPhaseIds.push(phase.id);
          selected.screening.push(...formIds);
        }
      }
    });
  });

  return selected;
};
